import { createFacetColumn, ColumnWidth } from '../createColumn';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { Facet } from '../../../models/Facet';
import ColumnStrings from '../columns.resx';
import { fileSizeFacet } from '../../../facets/ItemFacets';
import { FileSizeField } from '../../fields/fileSize/FileSizeField';

export const fileSizeColumn: IColumn = createFacetColumn({
  key: new Facet('fileSizeColumn').id,
  name: ColumnStrings.FileSize,
  fieldName: '',
  minWidth: ColumnWidth.regularMin,
  maxWidth: ColumnWidth.regularMax,
  isCollapsable: true
}, {
    fileSize: fileSizeFacet
  },
  FileSizeField)((facets: {
    fileSize?: typeof fileSizeFacet.type;
  }) => {
    return {
      size: facets.fileSize ? facets.fileSize : undefined
    };
  });
